// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Coin } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

const Points = ({ points }: { points?: number }) => {
  const { t } = useTranslation();

  if (!points) {
    return null;
  }

  return (
    <Box
      className={cn(
        'flex h-40 ml-12 mt-12 w-max bg-white items-center justify-center rounded-8 border border-border ps-8 pe-12 xs:flex-row xs:px-12',
      )}>
      <Coin className="me-8" fillColorToken="icon-secondary" height={20} width={20} />
      <Typography color="text-text-paragraph" variant="body-short-02">
        {t('Common:Points')}: {points}
      </Typography>
    </Box>
  );
};

export default Points;
